<template>
  <div class="wrapper">
    <div class="animated fadeIn" v-if="ready">
      <h1 slot="title" class="mt-2 text-uppercase text-left font-weight-bold">
        Estiba Guía de despacho #{{ waybillData.number }}
      </h1>

      <div id="areaImprimir">
        <div class="ml-3">
          <b-row>
            <b-col>
              <h1>Guía de despacho &nbsp;&nbsp;&nbsp;#{{ waybillData.number }}</h1>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <p>
                <strong>Cliente: {{ waybillData.recipient_company.company_name }}</strong> <br />
                Rut: {{ waybillData.recipient_company.company_number }} <br />
                Dirección: {{ waybillData.recipient_company.address1 }} <br />
                Contacto: {{ waybillData.recipient_company.contact_name }} <br />
                Fecha: {{ waybillData.waybill_date }} <br />
                Chofer: {{ waybillData.truck_driver }} <br />
                Patente: {{ waybillData.license_plate }} <br />
              </p>
            </b-col>
          </b-row>
        </div>
        <b-row>
          <b-col lg="1" md="1" sm="1">
            <b-img
              class="text-left"
              src="/img/camion.png"
              width="100px"
              height="280px"
              style="mix-blend-mode: multiply; transform: scaleX(-1)"
            ></b-img>
          </b-col>
          <b-col lg="11" md="11" sm="11">
            <grid-layout
              :layout.sync="layout"
              :col-num="20"
              :row-height="60"
              :is-draggable="draggable"
              :is-resizable="resizable"
              :use-css-transforms="true"
            >
              <grid-item
                v-for="(item, itemKey) in layout"
                :static="item.static"
                :x="item.x"
                :y="item.y"
                :w="item.w"
                :h="item.h"
                :i="item.i"
                :key="itemKey"
              >
                <b-card class="h-100 p-2" no-body bg-variant="secondary">
                  <span class="font-weight-bold">{{ item.data.number }}</span>
                  <ul class="small" style="padding-left: 12px">
                    <li>{{ item.data.contents[0].product_name }}</li>
                    <li>{{ item.data.contents[0].container_name }}</li>
                    <li>{{ item.data.total_quantity }} un</li>
                    <li>{{ item.data.total_net_kilograms }} kg</li>
                  </ul>
                </b-card>
              </grid-item>
            </grid-layout>
          </b-col>
        </b-row>
      </div>
      <hr />
      <b-row class="text-right">
        <b-col>
          <b-button class="ml-2" @click.prevent="descargarPDF">Imprimir</b-button>
          <b-button class="ml-2" variant="primary" @click.prevent="saveAndPrint">Imprimir y Guardar</b-button>
          <b-button class="ml-2" variant="primary" @click.prevent="saveWaybill">Guardar</b-button>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { GridLayout, GridItem } from "vue-grid-layout";
import html2pdf from "html2pdf.js";
import _ from "lodash";
export default {
  components: {
    GridLayout,
    GridItem
  },
  data() {
    return {
      ready: false,
      layout: [],
      draggable: true,
      resizable: false,
      index: 0,
      waybillData: {}
    };
  },
  mounted() {
    this.getWaybill(this.$route.params.id)
      .then((res) => {
        this.waybillData = res;
        const estiba = res.estiba;
        if (_.isEmpty(estiba)) {
          const items = 20;
          const rows = 2;
          const squareSize = 2;
          for (let i = 0; i < items; i++) {
            if (res.pallets.length > i) {
              this.layout.push({
                x: Math.floor(i / rows) * squareSize,
                y: (i % rows) * squareSize,
                w: squareSize,
                h: squareSize,
                i: i.toString(),
                static: false,
                data: res.pallets[i]
              });
            }
          }
        } else {
          this.layout = estiba;
        }
      })
      .finally(() => {
        this.ready = true;
      });
  },
  methods: {
    async getWaybill(id) {
      this.$store.dispatch("toggleOverlay");
      try {
        const response = await this.$axios.get(`/api/v1/waybill/${id}/waybill_complete_dispatch/`);
        return response.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.$store.dispatch("toggleOverlay");
      }
    },
    saveAndPrint() {
      this.descargarPDF();
      this.saveWaybill();
    },
    saveWaybill() {
      this.$store.dispatch("toggleOverlay");
      this.$axios
        .put(`/api/v1/waybill/${this.$route.params.id}/save_estiba/`, {
          estiba: this.layout
        })
        .then((res) => {
          console.log(res);
          this.$swal.fire({
            title: "Estiba guardada",
            text: "La estiba se ha guardado correctamente",
            icon: "success",
            confirmButtonText: "Aceptar"
          });
        })
        .catch((error) => {
          this.$swal.fire({
            title: "Error",
            text: "Ha ocurrido un error al guardar la estiba",
            icon: "error",
            confirmButtonText: "Aceptar"
          });
          console.log(error);
        })
        .finally(() => {
          this.$store.dispatch("toggleOverlay");
        });
    },
    descargarPDF() {
      const element = document.getElementById("areaImprimir");
      const opt = {
        margin: 0.25,
        image: { type: "png" },
        filename: `estiba guia ${this.waybillData.number}.pdf`,
        html2canvas: {
          width: element.offsetWidth
        },
        jsPDF: { unit: "in", format: "legal", orientation: "landscape" }
      };
      html2pdf(element, opt);
    }
  }
};
</script>
